import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Screenshots.scss';

import paper01 from '../../images/screenshot/paper_01.png';
import paper01pro from '../../images/screenshot/paper_01-2.png';
import paper02 from '../../images/screenshot/paper_02.png';
import paper03 from '../../images/screenshot/paper_03.png';
import paper04 from '../../images/screenshot/paper_04.png';
import paper05 from '../../images/screenshot/paper_05.png';

// import appinfo01 from '../../images/screenshot/appinfo_01.jpg';
// import appinfo02 from '../../images/screenshot/appinfo_02.jpg';
// import appinfo03 from '../../images/screenshot/appinfo_03.jpg';

const screenshots = [
  { src: paper01, title: 'PDF를 HWP로 변환' },
  { src: paper01pro, title: 'PDF2HWP PRO' },
  { src: paper02, title: '수학 문제 풀이 AI' },
  { src: paper03, title: '수학 문제 변형 AI' },
  { src: paper04, title: '수학 도형 그리기 AI' },
  { src: paper05, title: '수학 도형 전용 그림판' },
];

// const appScreenshots = [
//   { src: appinfo01, title: '' },
//   { src: appinfo02, title: '' },
//   { src: appinfo03, title: '' },
// ];

const Screenshots = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="screenshots section">
      <div className="container">
        <header className="header">
          <h2 className="title">
            <span className="title-accent">한눈에 보는</span> 스크린샷
          </h2>
          <p className="subtitle">실제 화면으로 확인하는 편리한 기능들</p>
        </header>

        <div className="list">
          {screenshots.map((screenshot, index) => (
            <div key={index} className="item" onClick={() => setSelectedImage(screenshot)}>
              <div className="item-title">{screenshot.title}</div>
              <img src={screenshot.src} alt={screenshot.title} />
            </div>
          ))}
        </div>

        {/* <div className="apps">
          <div className="apps-grid">
            {appScreenshots.map((screenshot, index) => (
              <div key={index} className="app-item" onClick={() => setSelectedImage(screenshot)}>
                <img src={screenshot.src} alt={screenshot.title} />
                <span className="app-label">{screenshot.title}</span>
              </div>
            ))}
          </div>
        </div> */}
      </div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="modal-content"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close" onClick={() => setSelectedImage(null)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
              <img src={selectedImage.src} alt={selectedImage.title} />
              <p className="modal-title">{selectedImage.title}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Screenshots;

